
import { computed, defineComponent } from 'vue';
import asynButtonVue from './asynButton.vue';

export default defineComponent({
  components: {
    myButton: asynButtonVue,
  },
  props: {
    bgcolor: {
      type: String,
      default: 'grey',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const className = `${props.bgcolor}-button`;

    const basicDisabled = computed(() => props.disabled);

    const basicLoading = computed(() => props.loading);

    return {
      className,
      basicDisabled,
      basicLoading,
    };
  },
});
